// import http from './../../../base/api/public'
// let service = require('@/../config/serviceList')
// let sysConfig = require('@/../config/sysConfig')
// let apiPre = sysConfig.apiPre
// service.res = ''
// export default {
//   getCards (params) {
//     console.log('params:' + JSON.stringify(params))
//     return http.requestPost(apiPre + service.res + '/card/getList', params)
//   }
// }
// 导入基本公共资源
import http from './../../../base/api/public'

let sysConfig = require('@/../config/sysConfig')
let service = require('@/../config/serviceList')
// 定义访问网关的api,分为开发，测试，以及生产环境
let apiPre = sysConfig.apiPre
export default {

  // 站
  getStationById(params) {
    return http.requestPost(apiPre + service.res + '/res/station/getStationById', params)
  },
  // 站
  getStations(params) {
    console.log('params:' + JSON.stringify(params))
    return http.requestPost(apiPre + service.res + '/res/station/getStations', params)
  },
  saveOrUpdateStation(params) {
    console.log('params:' + JSON.stringify(params))
    return http.requestPut(apiPre + service.res + '/res/station/saveOrUpdateStation', params)
  },
  parkPricesChange(params) {
    console.log('params:' + JSON.stringify(params))
    return http.requestPut(apiPre + service.res + '/res/station/parkPricesChange', params)
  },
  quickSaveStation(params) {
    console.log('params:' + JSON.stringify(params))
    return http.requestPut(apiPre + service.res + '/res/station/quickSaveStation', params)
  },
  deleteStation(params) {
    console.log('params:' + JSON.stringify(params))
    return http.requestPost(apiPre + service.res + '/res/station/deleteStation', params)
  },
  getRateSelectByOperatorId(params) {
    console.log('params:' + JSON.stringify(params))
    return http.requestPost(apiPre + service.res + '/res/rate/getRateSelectByOperatorId', params)
  },
  bindingRate(params) {
    console.log('params:' + JSON.stringify(params))
    return http.requestPost(apiPre + service.res + '/res/station/bindingRate', params)
  },
  getRateNameById(params) {
    console.log('params:' + JSON.stringify(params))
    return http.requestPost(apiPre + service.res + '/res/rate/getRateNameById', params)
  },
  queryRateGroupId(params) {
    console.log('params:' + JSON.stringify(params))
    return http.requestPost(apiPre + service.res + '/res/station/queryRateGroupId', params)
  },
  getStationEnumByOperatorId(params) {
    return http.requestGet(apiPre + service.res + '/res/station/getStationEnum/' + params)
  },
  getStationEnum(params) {
    console.log('params:' + JSON.stringify(params))
    return http.requestGet(apiPre + service.res + '/res/station/getStationEnum', params)
  },
  editSearchTabs(params) {
    console.log('params:' + JSON.stringify(params))
    return http.requestPut(apiPre + service.res + '/res/station/editSearchTabs', params)
  },
  getSearchTabs(params) {
    console.log('params:' + JSON.stringify(params))
    return http.requestPost(apiPre + service.res + '/res/station/getSearchTabs', params)
  },
  saveStationImg(params) {
  console.log('params:' + JSON.stringify(params))
  return http.requestPostFile(apiPre + service.res + '/res/station/saveStationImg', params)
  },
  getLogo(params) {
    console.log('params:' + JSON.stringify(params))
    return http.requestPost(apiPre + service.res + '/res/station/getLogo', params)
  },
  getPicture(params) {
    console.log('params:' + JSON.stringify(params))
    return http.requestPost(apiPre + service.res + '/res/station/getPicture', params)
  },
  uploadStationImg(params) {
    console.log('params:' + JSON.stringify(params))
    return http.requestPost(apiPre + service.res + '/res/station/uploadStationGuideImage', params)
  },
  createPileAndGun(params,isFile) {
    console.log('params:' + JSON.stringify(params));
    if(isFile){
      return http.requestPostFile(apiPre + service.res + '/res/station/createPileAndGun', params)
    }else{
      return http.requestPost(apiPre + service.res + '/res/station/createPileAndGun', params)
    }
  },
}



// WEBPACK FOOTER //
// ./src/module/resourceCenter/api/stationApi.js